import { ROW_HEIGHT } from "./ganttConstants";
/*
export function TimelineHeader({
  timelineStart,
  timelineEnd,
  pxPerDay
}: {
  timelineStart: Date;
  timelineEnd: Date;
  pxPerDay : number;
}) {
  return (
  //<div className="flex border-b bg-gray-50 text-xs font-semibold">
     
 <div className="relative h-8 border-b bg-gray-50 text-xs font-semibold"
     style={{ height: 48 }} // SAME as ROW_HEIGHT 
      > 
     
    </div>
  );
}*/

//Added TimelineHeader Correct
/*
export function TimelineHeader({
  timelineStart,
  timelineEnd,
  pxPerDay
} 
: {
  timelineStart: Date;
  timelineEnd: Date;
  pxPerDay: number;

}) 
{
  const days = Math.ceil(
    (timelineEnd.getTime() - timelineStart.getTime()) / 86400000
  );

  return (
    <div className="flex h-full">
      {Array.from({ length: days }).map((_, i) => {
        const date = new Date(timelineStart);
        date.setDate(date.getDate() + i);

        return (
          <div
            key={i}
            className="border-r text-xs flex items-center justify-center"
            style={{ width: pxPerDay }}
          >
            {date.getDate()}
          </div>
        );
      })}
    </div>
  );
}*/

//With month  TimelineHeader With month
/*type TimelineHeaderProps = {
  timelineStart: Date;
  timelineEnd: Date;
  pxPerDay: number;
};

export function TimelineHeader({
  timelineStart,
  timelineEnd,
  pxPerDay
}: TimelineHeaderProps) {
  const DAY_MS = 24 * 60 * 60 * 1000;
  const days = Math.ceil(
    (timelineEnd.getTime() - timelineStart.getTime()) / DAY_MS
  );

  return (
    <div className="flex h-full border-b bg-gray-50">
      {Array.from({ length: days }).map((_, i) => {
        const date = new Date(timelineStart);
        date.setDate(date.getDate() + i);

        const day = date.getDate();
        const month = date.toLocaleString("en-US", { month: "short" });

        const isMonthStart = day === 1;

        return (
          <div
            key={i}
            className={`h-full flex flex-col items-center justify-center border-r ${
              isMonthStart ? "bg-gray-100 font-semibold" : ""
            }`}
            style={{ width: pxPerDay }}
          >
            <div className="text-[10px] text-gray-500">
              {month}
            </div>
            <div className="text-xs">
              {day}
            </div>
          </div>
        );
      })}
    </div>
  );
}*/

//3rd Code with the Changes
/*type TimelineHeaderProps = {
  timelineStart: Date;
  timelineEnd: Date;
  pxPerDay: number;
};

const DAY_MS = 24 * 60 * 60 * 1000;

export function TimelineHeader({
  timelineStart,
  timelineEnd,
  pxPerDay
}: TimelineHeaderProps) {
  const days = Math.ceil(
    (timelineEnd.getTime() - timelineStart.getTime()) / DAY_MS
  );

  return (
    <div className="flex border-b bg-gray-50 sticky top-0 z-10">
      {Array.from({ length: days }).map((_, i) => {
        const date = new Date(timelineStart);
        date.setDate(date.getDate() + i);

        const day = date.getDate();
        const month = date.toLocaleString("en-US", { month: "short" });

        return (
          <div
            key={i}
            className="flex flex-col items-center justify-center border-r text-xs"
            style={{ width: pxPerDay, minWidth: pxPerDay }}
          >
            <div className="text-[10px] text-gray-500">
              {month}
            </div>
            <div className="font-medium">
              {day}
            </div>
          </div>
        );
      })}
    </div>
  );
}
*/

//final month timeline code

/*import { daysBetween } from "../../utils/ganttUtils";

type TimelineHeaderProps = {
  timelineStart: Date;
  timelineEnd: Date;
  pxPerDay: number;
};

export function TimelineHeader({
  timelineStart,
  timelineEnd,
  pxPerDay
}: TimelineHeaderProps) {
  const totalDays = daysBetween(timelineStart, timelineEnd);

  return (
    <div className="relative border-b bg-gray-50 h-[48px]">
      <div className="relative h-full">
        {Array.from({ length: totalDays }).map((_, i) => {
          const date = new Date(timelineStart);
          date.setDate(date.getDate() + i);

          const left = i * pxPerDay;

          const day = date.getDate();
          const month = date.toLocaleString("en-US", { month: "short" });

          return (
            <div
              key={i}
              className="absolute top-0 h-full border-r text-xs flex flex-col items-center justify-center"
              style={{
                left,
                width: pxPerDay
              }}
            >
              <div className="text-[10px] text-gray-500">{month}</div>
              <div className="font-medium">{day}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}*/

import { differenceInCalendarDays, startOfWeek, addDays, format } from "date-fns";

type TimelineHeaderProps = {
  timelineStart: Date;
  timelineEnd: Date;
  pxPerDay: number;
  zoom: "day" | "week" | "month" | "all";
};

/* ------------------------------------------------
   Helpers
-------------------------------------------------- */
function daysBetween(start: Date, end: Date) {
  return differenceInCalendarDays(end, start);
}

function buildDays(start: Date, total: number) {
  return Array.from({ length: total }, (_, i) => {
    const d = new Date(start);
    d.setDate(d.getDate() + i);
    return d;
  });
}

/* ------------------------------------------------
   Timeline Header
-------------------------------------------------- */
export function TimelineHeader({
  timelineStart,
  timelineEnd,
  pxPerDay,
  zoom
}: TimelineHeaderProps) {
  const totalDays = daysBetween(timelineStart, timelineEnd);
  const days = buildDays(timelineStart, totalDays);

  // ✅ ALL behaves like MONTH visually
  const effectiveZoom: "day" | "week" | "month" =
    zoom === "all" ? "month" : zoom;

  /* ---------------- MONTH GROUPS ---------------- */
  const months: { label: string; days: number }[] = [];

  days.forEach((d) => {
    const label = format(d, "MMM yyyy");
    const last = months[months.length - 1];

    if (!last || last.label !== label) {
      months.push({ label, days: 1 });
    } else {
      last.days++;
    }
  });

  /* ---------------- WEEK GROUPS ---------------- */
  const weeks: { label: string; days: number }[] = [];
  let i = 0;

  while (i < days.length) {
    const weekStart = startOfWeek(days[i], { weekStartsOn: 1 });
    const weekEnd = addDays(weekStart, 6);

    const daysInWeek = days.filter(
      (d) => d >= weekStart && d <= weekEnd
    ).length;

    weeks.push({
      label: `${format(weekStart, "dd")}–${format(weekEnd, "dd")}`,
      days: daysInWeek
    });

    i += daysInWeek;
  }

  return (
    
    //<div className="gantt-text border-b bg-gray-50 select-none">
       <div className="border-b bg-gray-50 select-none">

      {/* ---------------- TOP ROW (MONTHS) ---------------- */}
     {/* <div className="relative h-[24px] border-b bg-gray-100">*/}
        <div
  className={`relative border-b bg-gray-100 ${
    effectiveZoom === "month" ? "h-[48px]" : "h-[24px]"
  }`}
>
        {months.map((m, i) => {
          const left = months
            .slice(0, i)
            .reduce((sum, x) => sum + x.days * pxPerDay, 0);

          return (
            <div
              key={i}
              //className="absolute top-0 h-full flex items-center justify-center border-r text-xs font-semibold"
              className="absolute top-0 h-full flex items-center justify-center border-r text-xs font-semibold"
            // className="gantt-text absolute top-0 h-full flex items-center justify-center border-r text-xs font-semibold"
              style={{
                left,
                width: m.days * pxPerDay
              }}
            >
              {m.label}
            </div>
          );
        })}
      </div>

      {/* ---------------- BOTTOM ROW ---------------- */}
     {/* <div className="relative h-[24px]">*/}
     {effectiveZoom !== "month" && (
  <div className="relative h-[24px]">

        {effectiveZoom === "day" &&
          days.map((d, i) => (
            <div
              key={i}
              className="absolute top-0 h-full border-r flex items-center justify-center text-xs"
              //className="gantt-text absolute top-0 h-full border-r flex items-center justify-center text-xs"
              style={{
                left: i * pxPerDay,
                width: pxPerDay
              }}
            >
              {format(d, "d")}
            </div>
          ))}

        {effectiveZoom === "week" &&
          weeks.map((w, i) => {
            const left = weeks
              .slice(0, i)
              .reduce((sum, x) => sum + x.days * pxPerDay, 0);

            return (
              <div
                key={i}
                className="absolute top-0 h-full border-r flex items-center justify-center text-xs"
                //className="gantt-text absolute top-0 h-full border-r flex items-center justify-center text-xs"
                style={{
                  left,
                  width: w.days * pxPerDay
                }}
              >
                {w.label}
              </div>
            );
          })}

       {/* {effectiveZoom === "month" &&
          months.map((m, i) => {
            const left = months
              .slice(0, i)
              .reduce((sum, x) => sum + x.days * pxPerDay, 0);

            return (
              <div
                key={i}
                className="absolute top-0 h-full border-r flex items-center justify-center text-xs"
                //className="gantt-text absolute top-0 h-full border-r flex items-center justify-center text-xs"
                style={{
                  left,
                  width: m.days * pxPerDay
                }}
              >
                {m.label.split(" ")[0]}
              </div>
            );
          })}*/}
      
      </div>
     )}
    </div>
    
  );


}









/*
export function TimelineHeader({
  timelineStart,
  timelineEnd,
  pxPerDay
}: {
  timelineStart: Date;
  timelineEnd: Date;
  pxPerDay: number;
}) {
  const DAY_MS = 24 * 60 * 60 * 1000;

  const totalDays = Math.ceil(
    (timelineEnd.getTime() - timelineStart.getTime()) / DAY_MS
  );

  return (
    <div className="relative h-10 border-b bg-gray-50 text-xs font-semibold">
      
      {Array.from({ length: totalDays }).map((_, i) => {
        const d = new Date(timelineStart);
        d.setDate(d.getDate() + i);

        return (
          <div
            key={i}
            className="absolute top-0 bottom-0 border-l border-gray-200"
            style={{ left: i * pxPerDay }}
          >
            /* Date label */
           // <div className="absolute top-0 left-1 text-[10px] text-gray-600">
            //  {d.getDate()}
          //  </div>
         // </div>
      //  );
    //  })}
 //   </div>
 // );
//}
/*
import { daysBetween } from "../../utils/ganttUtils";

export function TimelineHeader({
  timelineStart,
  timelineEnd,
  pxPerDay
}: {
  timelineStart: Date;
  timelineEnd: Date;
  pxPerDay: number;
}) {
  const days = daysBetween(timelineStart, timelineEnd) + 1;

  return (
    <div className="relative h-8 border-b bg-gray-50 text-xs font-semibold">
      {Array.from({ length: days }).map((_, i) => {
        const date = new Date(timelineStart);
        date.setDate(date.getDate() + i);

        return (
          <div
            key={i}
            className="absolute top-0 h-full border-r border-gray-200 flex items-center justify-center text-gray-600"
            style={{
              left: i * pxPerDay,
              width: pxPerDay
            }}
          >
            {date.getDate()}
          </div>
        );
      })}
    </div>
  );
}
*/
